import $ from 'jquery'


/* Header scroll based classes
********************************************/

const el = $( '.site-header' );
let scrollTop = $( window ).scrollTop();
let lastScrollTop = 0;

if ( scrollTop > 150 ) {
	el.addClass( 'header-scrolled-pos' );
} else {
	el.addClass( 'header-initial-pos' );
}

$( window ).on('scroll', function( event ){
	let scrollTop = $( this ).scrollTop();

	if ( scrollTop > 150 ) {
		el.removeClass( 'header-initial-pos' ).addClass( 'header-scrolled-pos' );
	} else {
		el.removeClass( 'header-scrolled-pos' ).addClass( 'header-initial-pos' );
	}

	if ( scrollTop > lastScrollTop ) {
		el.removeClass( 'header-up-mov' ).addClass( 'header-down-mov' );
	} else {
		el.removeClass( 'header-down-mov' ).addClass( 'header-up-mov' );
	}

	lastScrollTop = scrollTop
})




/* Header search
********************************************/

$( '.js-toggle-search' ).on( 'click', function( e ) {
	e.preventDefault();
	var $this = $(this);
	$this.toggleClass( 'is-active' );
	$( '.header-search' ).toggleClass( 'is-visible' );
	$( 'body' ).toggleClass( 'open-search' );
	setTimeout(function () {
		$( '.header-search input' ).get(0).focus();
	}, 500);
});

$( document ).on("keydown", function ( e ) {
	if ( e.key == "Escape" ) {
		$( '.header-search' ).removeClass( 'is-visible' );
		$( 'body' ).removeClass( 'open-search' );
	}
});

$( document ).on( 'click', function( e ) {
	if (!$(e.target).closest('.js-toggle-search').length) {
		if (!$(e.target).closest('.header-search').length) {
			$('.header-search').removeClass('is-visible');
			$('body').removeClass('open-search');
		}
	}
});



/* Offcanvas navigation
********************************************/

$('.js-offcanvas-toggle').on('click', function (e) {
	e.preventDefault();
	const $this = $(this);
	const offcanvasID = $this.attr('data-offcanvas');
	const $body = $('body');
	const $offcanvasToggleButtons = $(`.js-offcanvas-toggle[data-offcanvas="${offcanvasID}"]`);
	const $offcanvasItems = $( `.js-offcanvas[data-offcanvas="${offcanvasID}"]` );

	$this.toggleClass('is-active');
	$offcanvasToggleButtons.add($offcanvasItems).toggleClass('is-active', $this.hasClass('is-active'));

	if ( offcanvasID == 'navigation' ) {
		$body.toggleClass('u-overflow-hidden has-offcanvas-open', $this.hasClass('is-active'));
	} else if ( offcanvasID == 'filters' ) {
		$body.toggleClass('is-active--listing-filters', $this.hasClass('is-active'));
	}
});


// Close navigation when hit escape key
$('body').on('keydown', function (e) {
	const $body = $('body');
	if (e.key === 'Escape' && $body.hasClass('has-offcanvas-open')) {
		$body.removeClass('u-overflow-hidden has-offcanvas-open')
		$('.js-offcanvas-toggle[data-offcanvas="navigation"], .js-offcanvas[data-offcanvas="navigation"]').removeClass('is-active');
	}
});
